/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsPopupMrk = {
  init: function ($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsPopupMrk = $.extend(this, window.PXUTheme.getSectionData($section));
    this.open();

  },
  open: function() {
    $.fancybox.open({
      src: '[data-popup-mrk]',
      type: 'inline',
      opts: {
        baseClass: 'mrk-model-popup popup-modal',
        hash: false,
        infobar: false,
        toolbar: false,
        smallBtn: false,
        touch: {
          vertical: false,
          momentum: false
        },
        beforeShow: () => {
          // Remove previous slides (fix for theme editor)
          $('.mrk-popup-wrapper .popup-modal .fancybox-slide').empty();
        },
        afterShow: () => {
          // After content is loaded, attach event listener for custom close icon
          $(document).on('touchstart click', '.popup__close', () => {
            this.close();
          });
        },
        beforeClose: () => {
          // Prevent duplicate triggers for close icon click
          $('.mrk-popup-wrapper .popup__close').off();
        }
      }
    });
  },
  close: function() {
    $.fancybox.close($('[data-popup]'));
  },
  showThemeEditorState() {
    $('.mrk-popup-wrapper .popup-section').addClass('is-fixed-top'); // Prevent scroll to bottom
    this.open();
  },
  hideThemeEditorState() {
    $('.mrk-popup-wrapper .popup-section').removeClass('is-fixed-top');
    this.close();
  },
  unload: function ($section) {
    $.fancybox.destroy();
    $('.mrk-popup-wrapper .popup-modal .fancybox-slide').empty();
    $('.mrk-popup-wrapper .popup__close').off();
  }
}

/******/ })()
;